export default theme => ({
  row: {
    alignItems: "center",
    padding: "20px",
    backgroundColor: theme.palette.common.white,
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  rowContent: {
    marginRight: "10px",
    marginLeft: "10px"
  },
  listHeader: {
    justifyContent: "space-between"
  }
});
